import { createContext, useContext, useState } from "react";
import { SupportedDeviceModal } from "../components";

const SupportedDeviceContext = createContext({
  showModal: false,
  setShowModal: (val: boolean) => {},
});

export const SupportedDeviceContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <SupportedDeviceContext.Provider
      value={{
        showModal,
        setShowModal,
      }}
    >
      {children}
      <SupportedDeviceModal open={showModal} setOpen={setShowModal} />
    </SupportedDeviceContext.Provider>
  );
};
export const useSupportedDevice = () => {
  const SupportedDeviceValue = useContext(SupportedDeviceContext);
  return SupportedDeviceValue;
};
